import * as types from '../constants/action-types';
import { ActionStore } from '../../../../api/api-action-store';


export function getInviteData (inviteToken) {
  return dispatch => {
    // Dispatch action that read token is being requested.
    dispatch({ type: types.ACTION_STORE_FETCH_REQUEST });

    // Create action store
    ActionStore.readToken(inviteToken, (response) => {
      if (response.error) {
        return dispatch({ type: types.ACTION_STORE_FETCH_FAILURE });
      }
      const inviteData = _.get(response, ['data']) || {};
      const invite_data = { invite_data: inviteData };
      // Successful action store.
      return dispatch({
        type: types.ACTION_STORE_FETCH_SUCCESS,
        response: invite_data
      });
    });
  };
}
